import React from 'react';
import classNames from 'classnames';
import '../../assets/font-cop/css/font-cop.css';
import { ABSAntIcon } from './ABSAntIcon';

export interface IABSIconProps {
  type: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: (e?: any) => void;
  isAnt?: boolean;
  theme?: 'filled' | 'outlined' | 'twoTone'; // 只用于ant icon 类型
  size?: number;
}

class ABSIcon extends React.Component<IABSIconProps> {
  static defaultProps = {
    size: 14
  };

  render() {
    const {
      className,
      type,
      onClick,
      style,
      theme,
      isAnt,
      size
    } = this.props;
    if (isAnt) {
      return (
        <ABSAntIcon 
          type={type}
          className={className}
          theme={theme} 
          style={style}
          onClick={onClick}
          size={size}
        />
      );
    }
    const classes = classNames('abs-icon', 'fc', className, {
      [`fc-${type}`]: type,
    });
    return (
      <i 
        className={classes} 
        onClick={(e) => onClick ? onClick(e) : null} 
        style={{fontSize: size, ...style}} 
      />
    );
  }
}

export default ABSIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSIcon/index.tsx